var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"vue-vehicle-rate-line"},[_c('td',[_vm._v("\n        "+_vm._s(_vm.item.rateType)+"\n    ")]),_vm._v(" "),_c('td',{staticClass:"text-end font-weight-bold"},[_vm._v("\n        "+_vm._s(_vm._f("currencyFormatter")(_vm._f("vatExcluder")(_vm.calculatePrice(_vm.item.totalPrice))))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }